import React, { useEffect, useState, useMemo } from 'react';
import { Group, Rect, Image as KonvaImage, Text } from 'react-konva';
import { getApplianceItem } from '../../constants/catalogItems';

/**
 * Renderizador de Item do Catálogo 2D dentro do Konva Canvas
 * Converte o SVG técnico paramétrico para uma imagem HTML nativa em memória.
 */
const ApplianceElement = ({ element, isSelected, onClick, onTap }) => {
  const [imageObj, setImageObj] = useState(null);
  const catalogDef = useMemo(() => getApplianceItem(element.svgId), [element.svgId]);

  useEffect(() => {
    if (!catalogDef) return;

    // Criar SVG em string
    const strokeColor = isSelected ? '#ef4444' : '#0f172a';
    const strokeWidth = isSelected ? 2.5 : 2;
    const fillColor = '#ffffff';

    // Montar SVG markup com base no catalogDef
    let svgContent = '';
    if (catalogDef.id === 'cooktop_4b') {
      svgContent = `
        <rect x="1" y="1" width="58" height="50" rx="3" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <rect x="5" y="5" width="50" height="42" rx="2" fill="none" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="3,2" />
        <circle cx="18" cy="16" r="7" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="18" cy="16" r="3" fill="${strokeColor}" />
        <circle cx="42" cy="16" r="7" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="42" cy="16" r="3" fill="${strokeColor}" />
        <circle cx="18" cy="36" r="7" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="18" cy="36" r="3" fill="${strokeColor}" />
        <circle cx="42" cy="36" r="7" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="42" cy="36" r="3" fill="${strokeColor}" />
        <circle cx="53" cy="16" r="1.5" fill="${strokeColor}" />
        <circle cx="53" cy="23" r="1.5" fill="${strokeColor}" />
        <circle cx="53" cy="30" r="1.5" fill="${strokeColor}" />
        <circle cx="53" cy="37" r="1.5" fill="${strokeColor}" />
      `;
    } else if (catalogDef.id === 'cooktop_5b') {
      svgContent = `
        <rect x="1" y="1" width="73" height="50" rx="3" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <rect x="5" y="5" width="65" height="42" rx="2" fill="none" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="3,2" />
        <circle cx="37.5" cy="26" r="10" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="37.5" cy="26" r="4" fill="${strokeColor}" />
        <circle cx="16" cy="16" r="6" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="16" cy="16" r="2.5" fill="${strokeColor}" />
        <circle cx="59" cy="16" r="6" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="59" cy="16" r="2.5" fill="${strokeColor}" />
        <circle cx="16" cy="36" r="6" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="16" cy="36" r="2.5" fill="${strokeColor}" />
        <circle cx="59" cy="36" r="6" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="59" cy="36" r="2.5" fill="${strokeColor}" />
      `;
    } else if (catalogDef.id === 'sink_single') {
      svgContent = `
        <rect x="1" y="1" width="48" height="38" rx="3" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <rect x="6" y="8" width="38" height="26" rx="4" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="25" cy="21" r="3.5" fill="none" stroke="${strokeColor}" stroke-width="1.5" />
        <circle cx="25" cy="21" r="1.5" fill="${strokeColor}" />
        <circle cx="25" cy="4.5" r="2.5" fill="${strokeColor}" />
        <path d="M 25 4.5 L 25 11" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" />
      `;
    } else if (catalogDef.id === 'sink_double') {
      svgContent = `
        <rect x="1" y="1" width="78" height="43" rx="3" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <rect x="5" y="9" width="32" height="30" rx="3" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="21" cy="24" r="3" fill="none" stroke="${strokeColor}" stroke-width="1.5" />
        <circle cx="21" cy="24" r="1.5" fill="${strokeColor}" />
        <rect x="43" y="9" width="32" height="30" rx="3" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="59" cy="24" r="3" fill="none" stroke="${strokeColor}" stroke-width="1.5" />
        <circle cx="59" cy="24" r="1.5" fill="${strokeColor}" />
        <circle cx="40" cy="5" r="2.5" fill="${strokeColor}" />
        <path d="M 40 5 L 40 12" stroke="${strokeColor}" stroke-width="2" stroke-linecap="round" />
      `;
    } else if (catalogDef.id === 'fridge_standard') {
      svgContent = `
        <rect x="1" y="1" width="68" height="68" rx="2" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <line x1="1" y1="62" x2="69" y2="62" stroke="${strokeColor}" stroke-width="1.5" />
        <rect x="25" y="64" width="20" height="3" rx="1" fill="${strokeColor}" />
        <line x1="15" y1="15" x2="55" y2="15" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="4,4" />
        <line x1="15" y1="30" x2="55" y2="30" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="4,4" />
        <line x1="15" y1="45" x2="55" y2="45" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="4,4" />
      `;
    } else if (catalogDef.id === 'fridge_side_by_side') {
      svgContent = `
        <rect x="1" y="1" width="88" height="73" rx="2" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <line x1="40" y1="1" x2="40" y2="74" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <line x1="1" y1="67" x2="89" y2="67" stroke="${strokeColor}" stroke-width="1" />
        <rect x="30" y="69" width="8" height="3" rx="1" fill="${strokeColor}" />
        <rect x="42" y="69" width="8" height="3" rx="1" fill="${strokeColor}" />
      `;
    } else if (catalogDef.id === 'oven_tower') {
      svgContent = `
        <rect x="1" y="1" width="58" height="58" rx="2" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <rect x="6" y="6" width="48" height="44" rx="2" fill="none" stroke="${strokeColor}" stroke-width="1.5" />
        <circle cx="30" cy="28" r="10" fill="none" stroke="${strokeColor}" stroke-width="1.5" stroke-dasharray="3,2" />
        <rect x="12" y="52" width="36" height="3" rx="1" fill="${strokeColor}" />
      `;
    } else if (catalogDef.id === 'washing_machine') {
      svgContent = `
        <rect x="1" y="1" width="58" height="58" rx="3" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="30" cy="30" r="19" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <circle cx="30" cy="30" r="14" fill="none" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="3,3" />
        <line x1="1" y1="12" x2="59" y2="12" stroke="${strokeColor}" stroke-width="1.5" />
        <circle cx="48" cy="6" r="3" fill="none" stroke="${strokeColor}" stroke-width="1" />
        <rect x="8" y="4" width="14" height="4" rx="1" fill="${strokeColor}" />
      `;
    } else if (catalogDef.id === 'laundry_tank') {
      svgContent = `
        <rect x="1" y="1" width="48" height="48" rx="3" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <rect x="6" y="10" width="38" height="34" rx="3" fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <line x1="10" y1="16" x2="40" y2="16" stroke="${strokeColor}" stroke-width="1" />
        <line x1="10" y1="21" x2="40" y2="21" stroke="${strokeColor}" stroke-width="1" />
        <line x1="10" y1="26" x2="40" y2="26" stroke="${strokeColor}" stroke-width="1" />
        <circle cx="25" cy="36" r="2.5" fill="${strokeColor}" />
        <circle cx="25" cy="5" r="2.5" fill="${strokeColor}" />
      `;
    } else if (catalogDef.id === 'cabinet_base') {
      svgContent = `
        <rect x="1" y="1" width="58" height="58" rx="2" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
        <line x1="1" y1="1" x2="59" y2="59" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="4,4" />
        <line x1="1" y1="59" x2="59" y2="1" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="4,4" />
        <line x1="1" y1="56" x2="59" y2="56" stroke="${strokeColor}" stroke-width="${strokeWidth}" />
      `;
    } else if (catalogDef.id === 'cabinet_upper') {
      svgContent = `
        <rect x="1" y="1" width="58" height="33" rx="2" fill="${fillColor}" stroke="${strokeColor}" stroke-width="${strokeWidth}" stroke-dasharray="5,3" />
        <line x1="30" y1="1" x2="30" y2="34" stroke="${strokeColor}" stroke-width="1" stroke-dasharray="3,3" />
      `;
    }

    const fullSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${catalogDef.defaultWidth} ${catalogDef.defaultHeight}" width="${catalogDef.defaultWidth}" height="${catalogDef.defaultHeight}">
        ${svgContent}
      </svg>
    `.trim();

    const blob = new Blob([fullSvg], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const img = new window.Image();
    img.src = url;
    img.onload = () => {
      setImageObj(img);
    };

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [catalogDef, isSelected]);

  const width = element.width || catalogDef?.defaultWidth || 60;
  const height = element.height || catalogDef?.defaultHeight || 60;
  const rotation = element.rotation || 0;

  return (
    <Group
      x={element.x}
      y={element.y}
      width={width}
      height={height}
      rotation={rotation}
      offset={{ x: width / 2, y: height / 2 }}
      onClick={onClick}
      onTap={onTap}
    >
      {/* Imagem SVG Renderizada */}
      {imageObj && (
        <KonvaImage
          image={imageObj}
          width={width}
          height={height}
        />
      )}

      {/* Bounding box de seleção quando ativo */}
      {isSelected && (
        <Rect
          x={0}
          y={0}
          width={width}
          height={height}
          stroke="#ef4444"
          strokeWidth={2}
          dash={[4, 4]}
          fill="rgba(239, 68, 68, 0.05)"
        />
      )}

      {/* Rótulo de dimensões técnicas */}
      <Text
        text={`${Math.round(width)}×${Math.round(height)}`}
        x={width / 2 - 20}
        y={height + 4}
        fontSize={10}
        fontFamily="sans-serif"
        fill={isSelected ? '#ef4444' : '#64748b'}
        listening={false}
      />
    </Group>
  );
};

export default ApplianceElement;
